var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerAffichage2 containerIFrame",attrs:{"id":"containerProfessionnalisation2"}},[_c('bloc-professionnalisation',{attrs:{"sitePro":_vm.sitePro}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }